import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { FaTiktok, FaXTwitter, FaInstagram } from 'react-icons/fa6';
import { SignedIn, SignedOut, UserButton } from '@clerk/clerk-react';

function Layout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  
  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      flexDirection: 'column',
      backgroundColor: '#0a0e1a',
      color: '#ffffff'
    }}>
      {/* Sidebar */}
      {sidebarOpen && (
        <>
          {/* Overlay */}
          <div 
            onClick={() => setSidebarOpen(false)}
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.7)',
              zIndex: 998
            }}
          />
          
          {/* Sidebar */}
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            bottom: 0,
            width: '280px',
            backgroundColor: '#1a1f2e',
            borderRight: '1px solid #2d3748',
            zIndex: 999,
            padding: '30px',
            overflowY: 'auto'
          }}>
            {/* Close button */}
            <div style={{ 
              display: 'flex', 
              justifyContent: 'flex-end',
              marginBottom: '30px'
            }}>
              <div
                onClick={() => setSidebarOpen(false)}
                style={{
                  cursor: 'pointer',
                  padding: '8px',
                  borderRadius: '6px',
                  transition: 'all 0.2s'
                }}
                onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#2d3748'}
                onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
              >
                <X size={24} color="#64748b" />
              </div>
            </div>

            {/* Navigation sections */}
            <div style={{ marginBottom: '35px' }}>
              <h3 style={{
                fontSize: '12px',
                fontWeight: '700',
                color: '#64748b',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                marginBottom: '15px'
              }}>
                Analytics Tools
              </h3>
              <Link 
                to="/arbitrage" 
                onClick={() => { setSidebarOpen(false); window.scrollTo(0, 0); }}
                style={{ textDecoration: 'none' }}
              >
                <div style={{
                  padding: '12px 16px',
                  borderRadius: '8px',
                  marginBottom: '8px',
                  color: '#a0aec0',
                  fontSize: '15px',
                  fontWeight: '500',
                  transition: 'all 0.2s',
                  cursor: 'pointer'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = '#2d3748';
                  e.currentTarget.style.color = '#ffffff';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                  e.currentTarget.style.color = '#a0aec0';
                }}
                >
                  Arbitrage Tool
                </div>
              </Link>
              <Link 
                to="/positive-ev" 
                onClick={() => { setSidebarOpen(false); window.scrollTo(0, 0); }}
                style={{ textDecoration: 'none' }}
              >
                <div style={{
                  padding: '12px 16px',
                  borderRadius: '8px',
                  marginBottom: '8px',
                  color: '#a0aec0',
                  fontSize: '15px',
                  fontWeight: '500',
                  transition: 'all 0.2s',
                  cursor: 'pointer'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = '#2d3748';
                  e.currentTarget.style.color = '#ffffff';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                  e.currentTarget.style.color = '#a0aec0';
                }}
                >
                  Positive EV Tool
                </div>
              </Link>
              <Link 
                to="/promo-conversion" 
                onClick={() => { setSidebarOpen(false); window.scrollTo(0, 0); }}
                style={{ textDecoration: 'none' }}
              >
                <div style={{
                  padding: '12px 16px',
                  borderRadius: '8px',
                  color: '#a0aec0',
                  fontSize: '15px',
                  fontWeight: '500',
                  transition: 'all 0.2s',
                  cursor: 'pointer'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = '#2d3748';
                  e.currentTarget.style.color = '#ffffff';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                  e.currentTarget.style.color = '#a0aec0';
                }}
                >
                  Bonus Conversion Tool
                </div>
              </Link>
            </div>

            <div style={{ marginBottom: '35px' }}>
              <h3 style={{
                fontSize: '12px',
                fontWeight: '700',
                color: '#64748b',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                marginBottom: '15px'
              }}>
                Calculators
              </h3>
              <Link 
                to="/arbitrage-calculator" 
                onClick={() => { setSidebarOpen(false); window.scrollTo(0, 0); }}
                style={{ textDecoration: 'none' }}
              >
                <div style={{
                  padding: '12px 16px',
                  borderRadius: '8px',
                  marginBottom: '8px',
                  color: '#a0aec0',
                  fontSize: '15px',
                  fontWeight: '500',
                  transition: 'all 0.2s',
                  cursor: 'pointer'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = '#2d3748';
                  e.currentTarget.style.color = '#ffffff';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                  e.currentTarget.style.color = '#a0aec0';
                }}
                >
                  Arbitrage Calculator
                </div>
              </Link>
              <Link 
                to="/positive-ev-calculator" 
                onClick={() => { setSidebarOpen(false); window.scrollTo(0, 0); }}
                style={{ textDecoration: 'none' }}
              >
                <div style={{
                  padding: '12px 16px',
                  borderRadius: '8px',
                  marginBottom: '8px',
                  color: '#a0aec0',
                  fontSize: '15px',
                  fontWeight: '500',
                  transition: 'all 0.2s',
                  cursor: 'pointer'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = '#2d3748';
                  e.currentTarget.style.color = '#ffffff';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                  e.currentTarget.style.color = '#a0aec0';
                }}
                >
                  Positive EV Calculator
                </div>
              </Link>
              <Link 
                to="/promo-conversion-calculator" 
                onClick={() => { setSidebarOpen(false); window.scrollTo(0, 0); }}
                style={{ textDecoration: 'none' }}
              >
                <div style={{
                  padding: '12px 16px',
                  borderRadius: '8px',
                  color: '#a0aec0',
                  fontSize: '15px',
                  fontWeight: '500',
                  transition: 'all 0.2s',
                  cursor: 'pointer'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = '#2d3748';
                  e.currentTarget.style.color = '#ffffff';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                  e.currentTarget.style.color = '#a0aec0';
                }}
                >
                  Bonus Bet Calculator
                </div>
              </Link>
            </div>

            <div>
              <h3 style={{
                fontSize: '12px',
                fontWeight: '700',
                color: '#64748b',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                marginBottom: '15px'
              }}>
                Resources
              </h3>
              <Link 
                to="/about" 
                onClick={() => { setSidebarOpen(false); window.scrollTo(0, 0); }}
                style={{ textDecoration: 'none' }}
              >
                <div style={{
                  padding: '12px 16px',
                  borderRadius: '8px',
                  marginBottom: '8px',
                  color: '#a0aec0',
                  fontSize: '15px',
                  fontWeight: '500',
                  transition: 'all 0.2s',
                  cursor: 'pointer'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = '#2d3748';
                  e.currentTarget.style.color = '#ffffff';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                  e.currentTarget.style.color = '#a0aec0';
                }}
                >
                  About Us
                </div>
              </Link>
              <Link 
                to="/contact" 
                onClick={() => { setSidebarOpen(false); window.scrollTo(0, 0); }}
                style={{ textDecoration: 'none' }}
              >
                <div style={{
                  padding: '12px 16px',
                  borderRadius: '8px',
                  color: '#a0aec0',
                  fontSize: '15px',
                  fontWeight: '500',
                  transition: 'all 0.2s',
                  cursor: 'pointer'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = '#2d3748';
                  e.currentTarget.style.color = '#ffffff';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                  e.currentTarget.style.color = '#a0aec0';
                }}
                >
                  Contact Us
                </div>
              </Link>
            </div>
          </div>
        </>
      )}
      {/* Header */}
      <header style={{ 
        backgroundColor: '#1a1f2e',
        borderBottom: '1px solid #2d3748',
        position: 'sticky',
        top: 0,
        zIndex: 100
      }}>
        <div style={{ 
          maxWidth: '1400px',
          margin: '0 auto',
          padding: '20px 60px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          {/* Left side: Hamburger + Logo */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
            {/* Hamburger Menu */}
            <div
              onClick={() => setSidebarOpen(true)}
              style={{
                cursor: 'pointer',
                padding: '8px',
                borderRadius: '6px',
                transition: 'all 0.2s'
              }}
              onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#2d3748'}
              onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
            >
              <Menu size={24} color="#64748b" />
            </div>

            {/* Logo */}
            <Link to="/" onClick={() => window.scrollTo(0, 0)} style={{ textDecoration: 'none' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <img
                  src="/UBlogo.png"
                  alt="Upperline Bet"
                  style={{ height: '40px', width: 'auto', display: 'block' }}
                />
              </div>
            </Link>
          </div>
          
          <nav style={{ display: 'flex', gap: '30px', alignItems: 'center' }}>
            <Link 
              to="/tools" 
              style={{ 
                color: '#a0aec0', 
                textDecoration: 'none',
                fontSize: '15px',
                fontWeight: '500',
                transition: 'color 0.2s'
              }}
              onMouseOver={(e) => e.target.style.color = '#00d9ff'}
              onMouseOut={(e) => e.target.style.color = '#a0aec0'}
            >
              Tools
            </Link>
            <Link 
              to="/about" 
              style={{ 
                color: '#a0aec0', 
                textDecoration: 'none',
                fontSize: '15px',
                fontWeight: '500',
                transition: 'color 0.2s'
              }}
              onMouseOver={(e) => e.target.style.color = '#00d9ff'}
              onMouseOut={(e) => e.target.style.color = '#a0aec0'}
            >
              About
            </Link>
            <SignedOut>
              <Link to="/login">
                <button style={{
                  padding: '10px 20px',
                  backgroundColor: 'transparent',
                  border: '1px solid #2d3748',
                  borderRadius: '8px',
                  color: '#a0aec0',
                  fontSize: '14px',
                  fontWeight: '500',
                  cursor: 'pointer',
                  transition: 'all 0.2s'
                }}
                onMouseOver={(e) => {
                  e.target.style.borderColor = '#00d9ff';
                  e.target.style.color = '#00d9ff';
                }}
                onMouseOut={(e) => {
                  e.target.style.borderColor = '#2d3748';
                  e.target.style.color = '#a0aec0';
                }}
                >
                  Login
                </button>
              </Link>
              <Link to="/signup">
                <button style={{
                  padding: '10px 24px',
                  background: 'linear-gradient(135deg, #00d9ff 0%, #10b981 100%)',
                  border: 'none',
                  borderRadius: '8px',
                  color: '#0a0e1a',
                  fontSize: '14px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'transform 0.2s, box-shadow 0.2s',
                  boxShadow: '0 4px 12px rgba(0, 217, 255, 0.3)'
                }}
                onMouseOver={(e) => {
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 6px 20px rgba(0, 217, 255, 0.4)';
                }}
                onMouseOut={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 4px 12px rgba(0, 217, 255, 0.3)';
                }}
                >
                  Get Started
                </button>
              </Link>
            </SignedOut>
            <SignedIn>
              <UserButton
                userProfileUrl="/account"
                userProfileMode="navigation"
                appearance={{
                  variables: {
                    colorBackground: '#1a1f2e',
                    colorText: '#ffffff',
                    colorTextSecondary: '#a0aec0',
                    colorPrimary: '#00d9ff',
                    colorNeutral: '#a0aec0'
                  },
                  elements: {
                    avatarBox: { width: '36px', height: '36px' },
                    userButtonPopoverCard: { backgroundColor: '#1a1f2e', border: '1px solid #2d3748', boxShadow: '0 8px 32px rgba(0,0,0,0.6)' },
                    userButtonPopoverActionButton: { color: '#a0aec0' },
                    userButtonPopoverActionButton__manageAccount: { color: '#ffffff' },
                    userButtonPopoverActionButtonText: { color: '#a0aec0' },
                    userButtonPopoverActionButtonIcon: { color: '#a0aec0' },
                    userButtonPopoverFooter: { display: 'none' },
                    userPreview: { borderBottom: '1px solid #2d3748' },
                    userPreviewMainIdentifier: { color: '#ffffff' },
                    userPreviewSecondaryIdentifier: { color: '#64748b' }
                  }
                }}
              />
            </SignedIn>
          </nav>
        </div>
      </header>

      {/* Main Content */}
      <main style={{ flex: 1 }}>
        {children}
      </main>

      {/* Disclaimer */}
      <Link to="/disclaimer" onClick={() => window.scrollTo(0, 0)} style={{ textDecoration: 'none', display: 'block' }}>
        <div style={{
          backgroundColor: '#1a1f2e',
          border: '1px solid #2d3748',
          borderRadius: '12px',
          padding: '30px',
          marginTop: '60px',
          marginBottom: '60px',
          cursor: 'pointer',
          transition: 'border-color 0.2s'
        }}
        onMouseOver={(e) => e.currentTarget.style.borderColor = '#4a5568'}
        onMouseOut={(e) => e.currentTarget.style.borderColor = '#2d3748'}
        >
          <p style={{
            fontSize: '14px',
            color: '#64748b',
            lineHeight: '1.7',
            margin: 0
          }}>
            <strong style={{ color: '#a0aec0' }}>Legal Disclaimer:</strong> Sports betting involves substantial risk of loss. Only wager what you can afford to lose. We provide informational tools and analytics only — we do not facilitate betting or guarantee accuracy, availability, or profitability. Odds change rapidly and opportunities may no longer exist by the time you act. Data and odds displayed may be delayed or inaccurate; always verify with your sportsbook before placing a wager. This Service is intended for use only where permitted by local law. It is your responsibility to verify that use of sports betting analytics tools is lawful in your jurisdiction. You are solely responsible for complying with all applicable laws where you reside. Must be 18+. If you or someone you know has a gambling problem, call 1-800-GAMBLER or visit ncpgambling.org.
          </p>
        </div>
      </Link>

      {/* Footer */}
      <footer style={{ 
        padding: '60px 60px 40px',
        backgroundColor: '#1a1f2e',
        borderTop: '1px solid #2d3748'
      }}>
        <div style={{ 
          maxWidth: '1400px', 
          margin: '0 auto',
          display: 'grid',
          gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr',
          gap: '60px',
          marginBottom: '40px'
        }}>
          {/* Company Info */}
          <div>
            <img
              src="/UBlogo.png"
              alt="Upperline Bet"
              style={{ height: '36px', width: 'auto', display: 'block', marginBottom: '15px' }}
            />
            <p style={{ 
              fontSize: '14px', 
              lineHeight: '1.8',
              color: '#64748b',
              marginBottom: '20px'
            }}>
              Professional sports betting analytics platform. Find arbitrage opportunities, 
              positive EV bets, and optimize your bonus conversions.
            </p>
            <div style={{ display: 'flex', gap: '15px', marginTop: '20px' }}>
              <a href="YOUR_TIKTOK_URL" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                <div style={{
                  width: '36px',
                  height: '36px',
                  borderRadius: '50%',
                  backgroundColor: '#2d3748',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  transition: 'all 0.2s'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = '#00d9ff';
                  e.currentTarget.querySelector('svg').style.color = '#0a0e1a';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = '#2d3748';
                  e.currentTarget.querySelector('svg').style.color = '#64748b';
                }}
                >
                  <FaTiktok size={18} color="#64748b" />
                </div>
              </a>
              <a href="YOUR_X_URL" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                <div style={{
                  width: '36px',
                  height: '36px',
                  borderRadius: '50%',
                  backgroundColor: '#2d3748',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  transition: 'all 0.2s'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = '#00d9ff';
                  e.currentTarget.querySelector('svg').style.color = '#0a0e1a';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = '#2d3748';
                  e.currentTarget.querySelector('svg').style.color = '#64748b';
                }}
                >
                  <FaXTwitter size={18} color="#64748b" />
                </div>
              </a>
              <a href="YOUR_INSTAGRAM_URL" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                <div style={{
                  width: '36px',
                  height: '36px',
                  borderRadius: '50%',
                  backgroundColor: '#2d3748',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  transition: 'all 0.2s'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = '#00d9ff';
                  e.currentTarget.querySelector('svg').style.color = '#0a0e1a';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = '#2d3748';
                  e.currentTarget.querySelector('svg').style.color = '#64748b';
                }}
                >
                  <FaInstagram size={18} color="#64748b" />
                </div>
              </a>
            </div>
          </div>

          {/* Betting Tools */}
          <div>
            <h4 style={{ 
              marginTop: 0, 
              marginBottom: '20px',
              fontSize: '14px',
              fontWeight: '600',
              color: '#ffffff',
              textTransform: 'uppercase',
              letterSpacing: '0.5px'
            }}>
              Betting Tools
            </h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <Link 
                to="/arbitrage" 
                onClick={() => window.scrollTo(0, 0)}
                style={{ 
                  color: '#64748b', 
                  textDecoration: 'none',
                  fontSize: '14px',
                  transition: 'color 0.2s'
                }}
                onMouseOver={(e) => e.target.style.color = '#00d9ff'}
                onMouseOut={(e) => e.target.style.color = '#64748b'}
              >
                Arbitrage
              </Link>
              <Link 
                to="/positive-ev" 
                onClick={() => window.scrollTo(0, 0)}
                style={{ 
                  color: '#64748b', 
                  textDecoration: 'none',
                  fontSize: '14px',
                  transition: 'color 0.2s'
                }}
                onMouseOver={(e) => e.target.style.color = '#00d9ff'}
                onMouseOut={(e) => e.target.style.color = '#64748b'}
              >
                Positive EV
              </Link>
              <Link 
                to="/promo-conversion" 
                onClick={() => window.scrollTo(0, 0)}
                style={{ 
                  color: '#64748b', 
                  textDecoration: 'none',
                  fontSize: '14px',
                  transition: 'color 0.2s'
                }}
                onMouseOver={(e) => e.target.style.color = '#00d9ff'}
                onMouseOut={(e) => e.target.style.color = '#64748b'}
              >
                Bonus Conversion
              </Link>
            </div>
          </div>

          {/* Calculators */}
          <div>
            <h4 style={{ 
              marginTop: 0, 
              marginBottom: '20px',
              fontSize: '14px',
              fontWeight: '600',
              color: '#ffffff',
              textTransform: 'uppercase',
              letterSpacing: '0.5px'
            }}>
              Calculators
            </h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <Link 
                to="/arbitrage-calculator" 
                onClick={() => window.scrollTo(0, 0)}
                style={{ 
                  color: '#64748b', 
                  textDecoration: 'none',
                  fontSize: '14px',
                  transition: 'color 0.2s'
                }}
                onMouseOver={(e) => e.target.style.color = '#00d9ff'}
                onMouseOut={(e) => e.target.style.color = '#64748b'}
              >
                Arbitrage
              </Link>
              <Link 
                to="/positive-ev-calculator" 
                onClick={() => window.scrollTo(0, 0)}
                style={{ 
                  color: '#64748b', 
                  textDecoration: 'none',
                  fontSize: '14px',
                  transition: 'color 0.2s'
                }}
                onMouseOver={(e) => e.target.style.color = '#00d9ff'}
                onMouseOut={(e) => e.target.style.color = '#64748b'}
              >
                Expected Value
              </Link>
              <Link 
                to="/promo-conversion-calculator" 
                onClick={() => window.scrollTo(0, 0)}
                style={{ 
                  color: '#64748b', 
                  textDecoration: 'none',
                  fontSize: '14px',
                  transition: 'color 0.2s'
                }}
                onMouseOver={(e) => e.target.style.color = '#00d9ff'}
                onMouseOut={(e) => e.target.style.color = '#64748b'}
              >
                Bonus Conversion
              </Link>
            </div>
          </div>

          {/* Resources */}
          <div>
            <h4 style={{ 
              marginTop: 0, 
              marginBottom: '20px',
              fontSize: '14px',
              fontWeight: '600',
              color: '#ffffff',
              textTransform: 'uppercase',
              letterSpacing: '0.5px'
            }}>
              Resources
            </h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <Link 
                to="/about" 
                onClick={() => window.scrollTo(0, 0)}
                style={{ 
                  color: '#64748b', 
                  textDecoration: 'none',
                  fontSize: '14px',
                  transition: 'color 0.2s'
                }}
                onMouseOver={(e) => e.target.style.color = '#00d9ff'}
                onMouseOut={(e) => e.target.style.color = '#64748b'}
              >
                About Us
              </Link>
              <Link 
                to="/contact" 
                onClick={() => window.scrollTo(0, 0)}
                style={{ 
                  color: '#64748b', 
                  textDecoration: 'none',
                  fontSize: '14px',
                  transition: 'color 0.2s'
                }}
                onMouseOver={(e) => e.target.style.color = '#00d9ff'}
                onMouseOut={(e) => e.target.style.color = '#64748b'}
              >
                Contact Us
              </Link>
            </div>
          </div>

          {/* Account */}
          <div>
            <h4 style={{
              marginTop: 0,
              marginBottom: '20px',
              fontSize: '14px',
              fontWeight: '600',
              color: '#ffffff',
              textTransform: 'uppercase',
              letterSpacing: '0.5px'
            }}>
              Account
            </h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <SignedOut>
                <Link
                  to="/login"
                  onClick={() => window.scrollTo(0, 0)}
                  style={{
                    color: '#64748b',
                    textDecoration: 'none',
                    fontSize: '14px',
                    transition: 'color 0.2s'
                  }}
                  onMouseOver={(e) => e.target.style.color = '#00d9ff'}
                  onMouseOut={(e) => e.target.style.color = '#64748b'}
                >
                  Login
                </Link>
                <Link
                  to="/signup"
                  onClick={() => window.scrollTo(0, 0)}
                  style={{
                    color: '#64748b',
                    textDecoration: 'none',
                    fontSize: '14px',
                    transition: 'color 0.2s'
                  }}
                  onMouseOver={(e) => e.target.style.color = '#00d9ff'}
                  onMouseOut={(e) => e.target.style.color = '#64748b'}
                >
                  Sign Up
                </Link>
              </SignedOut>
              <Link
                to="/refer"
                onClick={() => window.scrollTo(0, 0)}
                style={{
                  color: '#64748b',
                  textDecoration: 'none',
                  fontSize: '14px',
                  transition: 'color 0.2s'
                }}
                onMouseOver={(e) => e.target.style.color = '#00d9ff'}
                onMouseOut={(e) => e.target.style.color = '#64748b'}
              >
                Refer a Friend
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div style={{
          paddingTop: '30px',
          borderTop: '1px solid #2d3748',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          fontSize: '13px',
          color: '#64748b'
        }}>
          <p style={{ margin: 0 }}>
            © 2026 Upperline Bet. All rights reserved.
          </p>
          <div style={{ display: 'flex', gap: '20px' }}>
            <Link to="/privacy-policy" onClick={() => window.scrollTo(0, 0)} style={{ color: '#64748b', textDecoration: 'none', fontSize: '14px' }}>Privacy Policy</Link>
            <Link to="/terms-of-service" onClick={() => window.scrollTo(0, 0)} style={{ color: '#64748b', textDecoration: 'none', fontSize: '14px' }}>Terms of Service</Link>
            <Link to="/disclaimer" onClick={() => window.scrollTo(0, 0)} style={{ color: '#64748b', textDecoration: 'none', fontSize: '14px' }}>Disclaimer</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Layout;